<template lang="pug">
div
  .md-headline Ingest Settings
  md-layout
    md-switch.md-primary(v-model='entity.useStitchCDN') Use Rhebus CDN to serve this content
  md-layout
    md-switch.md-primary(v-model='entity.transcodeSourceFiles') Transcode the videos in my feed
</template>

<script>
  export default {
    props: {
      entity: {
        type: Object,
        required: true
      }
    }
  };
</script>

<style lang="scss" scoped>
  .md-headline {
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/forms/IngestSettingsForm.vue